module.exports = __webpack_public_path__ + "img/pwd.f6604441.png";